import { WwWorkType } from '@/configs/enums/commons';

export default [
  {
    path: '/message/source',
    name: 'MessageSource',
    component: () => import('@/views/empty/message/MessageSource.vue'),
    meta: { layout: 'empty', title: '消息来源' },
  },
  {
    path: '/message/redirect',
    name: 'Redirect',
    component: () => import('@/views/empty/message/Redirect.vue'),
    meta: { layout: 'empty', title: '消息跳转', notNeedProgress: true },
  },
  {
    path: '/message/review/:id',
    name: 'message-review',
    component: () => import('@/views/admin/main/components/message/Review.vue'),
    meta: {
      layout: 'front',
      title: '消息详情',
      notNeedProgress: true,
      redirectType: WwWorkType.内部消息, // 跳转类型（用于当在企业微信环境下直接访问本页面时，路由自动判断处理成对应的跳转类型）
    },
  },
  {
    path: '/message/demo',
    name: 'message_demo',
    component: () => import('@/views/empty/message/Demo.vue'),
    meta: { layout: 'empty', title: 'Demo', notNeedProgress: true },
  },
];
